import React from 'react';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../../../Components/Form/FormWrapper';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import InputField from '../../../../../../Components/Form/components/InputField';
import CheckboxField from '../../../../../../Components/Form/components/CheckboxField';
// @ts-ignore
import styles from './PatientManualRegistrationMOU.module.scss';
import SubmitButton from '../../../../../../Components/Button/SubmitButton';
export interface PatientManualRegistrationMOUStep1Values {
	birthNumber: string;
	accept: boolean;
}

interface Props {
	onSuccess: (values: PatientManualRegistrationMOUStep1Values) => void;
}

const validationSchema = yup.object({
	birthNumber: yup
		.string()
		.min(9, 'validation.patientManualRegistrationMOUStep1.birthNumberMin')
		.max(11, 'validation.patientManualRegistrationMOUStep1.birthNumberMax')
		.required('validation.patientManualRegistrationMOUStep1.birthNumber'),
	accept: yup
		.boolean()
		.oneOf([true], 'validation.patientManualRegistrationMOUStep1.accept'),
});

const PatientManualRegistrationMOUStep1: React.FC<Props> = ({ onSuccess }) => {
	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = (values: any) => {
		onSuccess(values as PatientManualRegistrationMOUStep1Values);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.barcodeWrapper}>
				<img src={'/dist/placeholder/barcode-placeholder.svg'} alt='barcode' />
			</div>
			<FormWrapper formMethods={formMethods}>
				<div className='mb-3'>
					<InputField
						name='birthNumber'
						label='component.patientRegistrationStep1.patientsBirthNumber'
						isRequired
					/>
				</div>
				<div className='mb-5'>
					<CheckboxField
						name={'accept'}
						tx='component.patientRegistrationStep1.iConfirmPatientIdentity'
						isRequired
					/>
				</div>
				<SubmitButton
					onSubmit={handleSubmit}
					className='btn btn-green-global remastered w-100'
					title='base.shared.register'
				/>
			</FormWrapper>
		</div>
	);
};

export default PatientManualRegistrationMOUStep1;
